<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" class="text-center pb-0">
        <h3 class="kbDarkBlueText--text">
          {{ $t('general.insertEmailSubject') }}
        </h3>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-text-field v-model="localSubject"
                      color="kbDarkBlueText"
                      class="mt-4 text-center"
                      hide-details
                      style="max-width: 600px; margin: auto"
                      :label="$t('general.subject')"
                      ref="emailSubjectField"
                      outlined
                      single-line
                      clearable
                      :rules="[rules.required]"
                      v-on="{click: signalEmailSubjectHandler, keyup: signalEmailSubjectHandler}"/>
      </v-col>

      <v-col class="text-center" cols="12" >
        <btn-customize-field  :propModif="'subject'"
                              color="mainButtons"
                              :itemToCustomize="$t('general.subject')"
                              :domElemCursorPosition="'emailSubjectCaretPosition'"
                              :accessDataObject="'email'"
                              @customizeMessage="customizeMessage"/>
      </v-col>

      <v-col cols="12" class="d-flex align-center justify-end">
        <v-btn color="mainButtons"
               dark
               @click="updateStep(2)"
               class="float-right">
          <span class="hidden-xs-only">{{ $t('general.continue') }}</span>
          <v-icon dark>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import customMessages from '@/libs/customMessages'
import rules from '@/libs/rules'
import BtnCustomizeField from '@/pages/App/Communications/CustomizeFields/BtnCustomizeField.vue'
export default {
  components: { BtnCustomizeField },
  computed: {
    localSubject: {
      get () {
        return this.subject
      },
      set (value) {
        this.$emit('onSubjectChange', value)
      }
    }
  },
  data () {
    return {
      emailSubjectCaretPosition: 0,
      rules
    }
  },
  methods: {
    setCursor (event, caretPos, elemModifCaretPos) {
      if (caretPos === undefined || caretPos === null) {
        // find parent element which is code tag for processing cursor pos
        const element = event.path.filter(function (el) {
          return el.nodeName === 'CODE'
        })[0]
        caretPos = this.getCaretPosition(element)
      }
      this[elemModifCaretPos] = caretPos
    },
    signalEmailSubjectHandler (event) {
      const textarea = this.$refs.emailSubjectField.$refs.input
      const cursorPosition = textarea.selectionStart
      this.setCursor(event, cursorPosition, 'emailSubjectCaretPosition')
    },
    getCaretPosition (element) {
      // https://stackoverflow.com/a/4812022
      let caretOffset = 0
      const doc = element.ownerDocument || element.document
      const win = doc.defaultView || doc.parentWindow
      let sel
      if (typeof win.getSelection !== 'undefined') {
        sel = win.getSelection()
        if (sel.rangeCount > 0) {
          const range = win.getSelection().getRangeAt(0)
          const preCaretRange = range.cloneRange()
          preCaretRange.selectNodeContents(element)
          preCaretRange.setEnd(range.endContainer, range.endOffset)
          caretOffset = preCaretRange.toString().length
        }
      } else if ((sel = doc.selection) && sel.type !== 'Control') {
        const textRange = sel.createRange()
        const preCaretTextRange = doc.body.createTextRange()
        preCaretTextRange.moveToElementText(element)
        preCaretTextRange.setEndPoint('EndToEnd', textRange)
        caretOffset = preCaretTextRange.text.length
      }
      return caretOffset
    },
    customizeMessage (item) {
      const src = this.localSubject
      const caretPos = this.emailSubjectCaretPosition
      const value = ` ${item.value} `
      this.localSubject = customMessages.customizeMessage(value, src, caretPos)
      this.emailSubjectCaretPosition = caretPos + value.length
    },
    updateStep (step) {
      if (!this.$refs.form.validate()) return
      this.$emit('onStepChange', step)
    }
  },
  props: {
    subject: {
      type: String,
      default: ''
    }
  }
}
</script>
